import { PointOfInterestAPI } from '../../../api/datamanager/PointOfInterestAPI';

export class PointsOfInterestCommand {
    get(edition, successCallback, errorCallback) {
        const apiResult = PointOfInterestAPI.list(edition.county);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((_) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os pontos de interesse");
            }
        });
    }

    save(edition, poi, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === poi.id || 0 === poi.id) {
            apiResult = PointOfInterestAPI.create(edition.county, poi);
            successMessage = "Ponto de interesse criado com sucesso";
        }
        else {
            apiResult = PointOfInterestAPI.update(edition.county, poi.id, poi);
            successMessage = "Ponto de interesse editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, poiId, successCallback, errorCallback) {
        const apiResult = PointOfInterestAPI.delete(edition.county, poiId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "Ponto de interesse eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/commands/PointsOfInterestCommand.js